// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"51f81e66","787":"6404725f"}[chunkId] + ".chunk.js";
};